import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import CloseIcon from '@material-ui/icons/Close'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
        background: 'transparent',
        border: 0,
        cursor: 'pointer',
    },
    title: {
        margin: 0,
        padding: theme.spacing(2),
        fontSize: '1.1rem',
        fontWeight: 600,
    },
    body: { padding: theme.spacing(2) },
}))

const EditableDialogWrapper = ({
    id,
    children,
    title,
    open,
    onClose,
    onEntered,
}) => {
    const classes = useStyles()

    const callOnEntered = () => {
        if (onEntered) onEntered()
    }

    return (
        <Dialog
            id={id}
            open={open}
            onClose={onClose}
            onEntered={callOnEntered}
            aria-label='Editable dialog'
            aria-labelledby='title'
            fullWidth
            maxWidth={'md'}
        >
            {title ? (
                <div id='title' className={classes.title}>
                    {title}
                </div>
            ) : null}
            <div className={classes.body}>{children}</div>
            <button
                type='button'
                className={classes.closeButton}
                onClick={onClose}
                aria-label='Close dialog'
            >
                <CloseIcon aria-hidden='true' />
            </button>
        </Dialog>
    )
}

EditableDialogWrapper.propTypes = {
    id: PropTypes.string,
    children: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    onEntered: PropTypes.func,
}

export default EditableDialogWrapper
